<template>
  <div :class="[companyClass, canScroll]" class="page-addtransaction scrollable only-y"
    v-show="userPermissionsFilter.addusers" v-loading="pageLoading" :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="
              page-table
              flex
              column
              scrollable
              only-y
              mb-20
              col-xs-12 col-md-12
              p-10
            " :class="{ flex: !isMobile, overflow: isMobile }" id="page-contacts">
      <div class="col-xs-12 col-md-12 p-10 form-box p-0">
        <div class="row">
          <div class="container-xl p-0">
            <div class="table-responsive">
              <div class="table-wrapper">
                <div class="table-title">
                  <div class="row">
                    <div class="col-sm-6">
                      <!-- <h1 class="mt-0 pageTitle">Create New Directors</h1> -->
                      <h2>Manage {{ this.companydata.fullName }} Directors</h2>
                    </div>
                    <div class="col-sm-6">
                      <a @click="addDirector()" class="btn btn-success"><i class="mdi mdi-account-plus"></i><span>Add
                          New
                          Director</span></a>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table" id="datatable" style="color: white">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <!-- <th>Address</th>
                      <th>DOB</th>
                      <th>Gender</th> -->
                        <!-- <th>City</th> -->
                        <th>Nationality</th>
                        <th>Document Type</th>
                        <th>ID Number</th>
                        <!-- <th>Created By</th>
                      <th>Created On</th> -->
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in usersdata" :key="item.userID">
                        <td>
                          {{ item.firstName }} {{ item.middleName }}
                          {{ item.lastName }}
                        </td>
                        <td>{{ item.email }}</td>
                        <td>{{ item.phoneNumber }}</td>
                        <!-- <td>{{item.address}}</td>
                      <td>{{formatDate(item.dob)}}</td>
                      <td>{{item.gender}}</td> -->
                        <!-- <td>{{item.city}}</td> -->
                        <td>{{ item.countryName }}</td>
                        <td>{{ item.documentTypeName }}</td>
                        <td>{{ item.iDdocumentNumber }}</td>
                        <!-- <td>{{item.createdBy}}</td>
                      <td>{{formatDate(item.createdOn)}}</td> -->
                        <td>
                          <a v-show="userPermissionsFilter.approveusers" @click="editDirector(item)"><i
                              class="mdi mdi-border-color"></i>Edit</a>
                          <a @click="deleteDirector(item)"><i class="mdi mdi-delete"></i>Delete</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <el-dialog :show-close="true" :custom-class="'user-dialog'" :visible="dialogFormVisible" @close="closeDialog"
          :before-close="handleClose">
          <el-row :gutter="24">
            <el-col :span="8">
              <strong>First Name:</strong> <span :class="required">*</span>
              <el-input placeholder="First Name" v-model="userdata.firstName" name="FirstName" v-validate="'required'"
                data-vv-as="FirstName"></el-input>
              <transition name="fade"><span class="danger-text">{{
                errors.first("FirstName")
                  }}</span></transition>
            </el-col>
            <el-col :span="8">
              <strong>Middle Name:</strong> <span :class="required">*</span>
              <el-input placeholder="Middle Name" v-model="userdata.middleName" name="MiddleName"
                data-vv-as="MiddleName"></el-input>
              <transition name="fade"><span class="danger-text">{{
                errors.first("MiddleName")
                  }}</span></transition>
            </el-col>
            <el-col :span="8">
              <strong>Last Name:</strong>
              <el-input placeholder="Last Name" v-model="userdata.lastName" name="LastName" v-validate="'required'"
                data-vv-as="LastName"></el-input>
              <transition name="fade"><span class="danger-text">{{
                errors.first("LastName")
                  }}</span></transition>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <strong>Email:</strong>
              <el-input type="email" placeholder="Email" v-model="userdata.email" name="Email" v-validate="'required'"
                data-vv-as="Email"></el-input>
              <transition name="fade"><span class="danger-text">{{
                errors.first("Email")
                  }}</span></transition>
            </el-col>
            <el-col :span="8">
              <strong>Phone Number:</strong>
              <VuePhoneNumberInput v-model="plainphone" color="dodgerblue" style="line-height: 1"
                :default-country-code="countrycode" clearable class="mb-2" @update="onUpdatecustomerMobileNumber" />
              <transition name="fade"><span class="danger-text">{{
                errors.first("plainphone")
                  }}</span></transition>
            </el-col>

            <el-col :span="8">
              <strong>Date Of Birth:</strong>
              <el-date-picker placeholder="Date of Birth" name="DOB" style="width: 100%" v-model="userdata.dob"
                type="date" format="yyyy-MM-dd" :picker-options="{ disabledDate: disableLessThan18Dates }"
                v-validate="'required'" data-vv-as="date of birth"></el-date-picker>
              <transition name="fade"><span class="danger-text">{{
                errors.first("DOB")
                  }}</span></transition>
            </el-col>
            <el-col :span="8">
              <strong>Gender:</strong>
              <el-select v-model="userdata.gender" filterable clearable placeholder="Select Gender" class="mb-10"
                style="width: 100%" name="Gender" v-validate="'required'" data-vv-as="Gender">
                <el-option label="Male" value="Male"></el-option>
                <el-option label="Female" value="Female"></el-option>
                <el-option label="Other" value="Undefined"></el-option>
              </el-select>
              <transition name="fade"><span class="danger-text">{{
                errors.first("Gender")
                  }}</span></transition>
            </el-col>

            <el-col :span="8">
              <strong>Country:</strong>
              <el-select v-model="userdata.countryID" filterable clearable placeholder="Country" class="mb-10"
                style="width: 100%" name="CountryID" v-validate="'required'" data-vv-as="CountryID"
                @change="countryChanged($event)" :readonly="true" :disabled="true">
                <el-option v-for="country in countries" :key="country.id" :label="country.name" :value="country.id"
                  :selected="userdata.countryID"></el-option>
              </el-select>
              <transition name="fade">
                <span class="danger-text">{{
                  errors.first("CountryID")
                }}</span>
              </transition>
            </el-col>
            <el-col :span="8">
              <span>County</span>
              <span :class="required">*</span>
              <el-select v-model="userdata.state" filterable clearable placeholder="County" style="width: 100%"
                name="rState" data-vv-as="County" @change="receivingStateChanged($event)">
                <el-option v-for="mProvider in States" :key="mProvider.Id" :label="mProvider.Name"
                  :value="mProvider.Name"></el-option>
              </el-select>
              <transition name="fade"><span class="danger-text">{{
                errors.first("rState")
                  }}</span></transition>
            </el-col>

            <el-col :span="8">
              <span>City</span>
              <span :class="required">*</span>
              <el-select v-model="userdata.city" filterable clearable placeholder="City" style="width: 100%"
                name="rcity" data-vv-as="city">
                <el-option v-for="mProvider in Cities" :key="mProvider.Id" :label="mProvider.Name"
                  :value="mProvider.Name"></el-option>
              </el-select>
              <transition name="fade"><span class="danger-text">{{
                errors.first("rcity")
                  }}</span></transition>
            </el-col>
            <el-col :span="8">
              <strong>Address:</strong>
              <el-input type="text" placeholder="Address" v-model="userdata.address" name="Address"
                v-validate="'required'" data-vv-as="Address"></el-input>
              <transition name="fade"><span class="danger-text">{{
                errors.first("Address")
                  }}</span></transition>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="8">
              <strong>Document Type:</strong>
              <el-select v-model="userdata.documentTypeID" filterable clearable placeholder="Select Document Type"
                class="mb-10" style="width: 100%" name="DocumentTypeID" v-validate="'required'"
                data-vv-as="DocumentTypeID">
                <el-option v-for="documentType in documentTypes" :key="documentType.id" :label="documentType.name"
                  :value="documentType.id"></el-option>
              </el-select>
              <transition name="fade">
                <span class="danger-text">{{
                  errors.first("DocumentTypeID")
                }}</span>
              </transition>
            </el-col>
            <el-col :span="8">
              <strong>Document Number:</strong>
              <el-input type="text" placeholder="Document Number" v-model="userdata.iDdocumentNumber"
                name="iDdocumentNumber" v-validate="'required'" data-vv-as="iDdocumentNumber"></el-input>
              <transition name="fade"><span class="danger-text">{{
                errors.first("iDdocumentNumber")
                  }}</span></transition>
            </el-col>
            <el-col :span="8">
              <strong>Document Expiry:</strong>
              <el-date-picker placeholder="Document Expiry" name="ExpiryDate" style="width: 100%"
                v-model="userdata.expiryDate" type="date" format="yyyy-MM-dd"
                :picker-options="{ disabledDate: disableAllDatesBeforeToday }" data-vv-as="ExpiryDate"></el-date-picker>
              <transition name="fade"><span class="danger-text">{{
                errors.first("ExpiryDate")
                  }}</span></transition>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="9">
              <el-row :gutter="24">
                <el-col :span="12">
                  <h2 class="m-0">Profile Picture</h2>
                  <code v-if="device"><!--<strong>Current Camera</strong>> {{ device.label }}--></code><code
                    v-else>No Camera Selected</code>
                  <div class="border">
                    <vue-web-cam ref="webcam" height="" :device-id="deviceId" width="100%" @started="onStarted"
                      @stopped="onStopped" @error="onError" @cameras="onCameras" @camera-change="onCameraChange" />
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      Select Camera
                      <select v-model="camera">
                        <option>-- Select Device --</option>
                        <option v-for="device in devices" :key="device.deviceId" :value="device.deviceId">
                          {{ device.label }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-12">
                      <button type="button" class="el-button el-button--success p-4 m-2" @click="onStart">
                        <i class="mdi mdi-camera-iris"></i>Start Camera
                      </button>
                      <button type="button" class="el-button el-button--primary p-4 m-2" @click="onCapture">
                        <i class="mdi mdi-camera"></i>Capture Photo
                      </button>
                      <button type="button" class="el-button el-button--danger p-4 m-2" @click="onStop">
                        <i class="mdi mdi-camera-off"></i>Stop Camera
                      </button>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <h2 class="m-0 text-center">Picture</h2>
                  <div class="row">
                    <figure class="figure">
                      <img :src="img" class="img-responsive" style="max-width: 100%" />
                    </figure>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="15" class="p-4">
              <el-row :gutter="24">
                <!-- <el-col :span="24">
                  <strong>User Identification Document: </strong> <span v-for="doc in documentTypes" :key="doc.id"><span v-if="doc.id==userdata.documentTypeID">({{ doc.name }})</span></span>
                  <el-button @click="onPickFile">User Identification Document</el-button>
                </el-col>  -->
                <el-col :span="12" class="mb-4">
                  <strong>Upload Front Side ID</strong>
                  <input type="file" id="files" ref="files" accept="image/*" v-on:change="handleIndividualFilesUpload()"
                    style="display: none" />
                  <el-button type="warning" class="btn-group" v-show="userPermissionsFilter.approveusers"
                    @click="onPickFile($event, 'ID')"><i class="mdi mdi-account-check"></i><span> Upload
                      ID</span></el-button>
                  <div v-for="item in iDFile" :key="item.name">
                    <span v-if="item.name == 'ID'"><img v-bind:src="item.url" width="auto" height="100px" /></span>
                  </div>
                </el-col>
                <el-col :span="12" class="mb-4">
                  <strong>Upload Back Side ID</strong>
                  <input type="file" id="files" ref="files" accept="image/*" v-on:change="handleIndividualFilesUpload()"
                    style="display: none" />
                  <el-button type="warning" class="btn-group" v-show="userPermissionsFilter.approveusers" data-id=""
                    @click="onPickFile($event, 'ID-B')"><i class="mdi mdi-account-check"></i><span> Upload ID Back
                      Side</span></el-button>
                  <div v-for="item in iDFile" :key="item.name">
                    <span v-if="item.name == 'ID-B'"><img v-bind:src="item.url" width="auto" height="100px" /></span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12" class="mb-4 mt-12" v-if="userdata.countryID == 212">
                  <strong>Upload Word Permit</strong>
                  <input type="file" id="files" ref="files" accept="image/*" v-on:change="handleIndividualFilesUpload()"
                    style="display: none" />
                  <el-button type="warning" class="btn-group" v-show="userPermissionsFilter.approveusers" data-id=""
                    @click="onPickFile($event, 'WORK_PERMIT')"><i class="mdi mdi-account-check"></i><span> Upload Work
                      Permit</span></el-button>
                  <div v-for="item in iDFile" :key="item.name">
                    <span v-if="item.name == 'WORK_PERMIT'"><img v-bind:src="item.url" width="auto"
                        height="100px" /></span>
                  </div>
                </el-col>
                <el-col :span="12" class="mb-4 mt-12" v-if="userdata.countryID == 212">
                  <strong>Upload Special Pass</strong>
                  <input type="file" id="files" ref="files" accept="image/*" v-on:change="handleIndividualFilesUpload()"
                    style="display: none" />
                  <el-button type="warning" class="btn-group" v-show="userPermissionsFilter.approveusers" data-id=""
                    @click.prevent="onPickFile($event, 'SPECIAL_PASS')"><i class="mdi mdi-account-check"></i><span>
                      Upload
                      Special Pass</span></el-button>
                  <div v-for="item in iDFile" :key="item.name">
                    <span v-if="item.name == 'SPECIAL_PASS'"><img v-bind:src="item.url" width="auto"
                        height="100px" /></span>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="24">
              <el-button type="success" class="btn-group" style="width: 30%"
                v-show="userPermissionsFilter.approveusers && !userdata.id" @click="CreateNewDirector">
                <i class="mdi mdi-account-check"></i><span> Create Director</span>
              </el-button>
              <el-button type="success" class="btn-group" style="width: 30%"
                v-show="userPermissionsFilter.approveusers && userdata.id" @click="UpdateDirector">
                <i class="mdi mdi-account-check"></i><span> Update Director</span>
              </el-button>
            </el-col>
          </el-row>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import $ from "jquery";

import PermissionsMixins from "@/mixins/PermissionsMixins";
import { bus } from "@/main";
import UploadService from "@/UploadFilesService";
import { Validator } from "vee-validate";
import router from "@/router/";
import { CollapsePlugin } from "bootstrap-vue";

import { WebCam } from "vue-web-cam";

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  name: "AddADirector",
  components: {
    VuePhoneNumberInput,
    "vue-web-cam": WebCam,
  },
  data() {
    return {
      countries: "",
      countrycode: "",
      States: [],
      Cities: [],
      iDFile: [], //reupload id for customer
      identityDocumentTypes: [],
      file: undefined,
      filename: "",
      plainphone: "",
      files: [],
      pdfSrc: [],
      currentFile: undefined,
      img: null,
      camera: null,
      deviceId: null,
      devices: [],

      DocumentUpload: {
        DocumentId: "",
        userId: "",
        files: "",
      },
      currentName: undefined,
      companydata: {
        userID: "",
        FullName: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        countryID: "",
      },
      usersdata: [],
      userdata: {
        id: 0,
        companyId: "",
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        address: "",
        dob: "",
        gender: "",
        state: "",
        city: "",
        countryID: "",
        countryName: "",
        relationShip: "",
        nickName: "",
        documentTypeID: "",
        iDdocumentNumber: "",
        expiryDate: "",
        picture: "",
        file: null,
      },
    };
  },
  computed: {
    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
    contactsClass() {
      return this.pageWidth >= 870
        ? "large"
        : this.pageWidth >= 760
          ? "medium"
          : "small";
    },
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one by default
      const [first, ...tail] = this.devices;
      // if (first) {
      //     this.camera = first.deviceId;
      //     this.deviceId = first.deviceId;
      // }
    },
  },
  methods: {
    addDirector() {
      this.dialogFormVisible = true;
    },
    editDirector(data) {
      if (data) {
        this.userdata.plainphone = data.phoneNumber;
        this.dialogFormVisible = true;
        this.userdata = data;
      }
    },
    deleteDirector(data) {
      if (data) {
        this.deleteCompanyDirector(data.id)
          .then((result) => {
            this.stopLoader();
            if (result) {
              this.successMessage("Director Removed successifully.");
            }
            this.fetchDirectors();
          })
          .catch((err) => {
            this.errorMessage("Failed to delete Directors." + err);
            this.stopLoader();
          });
      }
    },
    countryChanged(event) {
      const codesn = this.countries.map((err) => {
        if (err.id == event) {
          this.countrycode = err.code;
          return err.code;
        } else {
        }
      });
      this.getStates(event)
        .then((result) => {
          this.States = result;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    receivingStateChanged(event) {
      let statecode = "";
      const codesn = this.States.map((err) => {
        if (err.Name == event) {
          statecode = err.Id;
          return err.code;
        } else {
        }
      });
      this.getCities(this.userdata.countryID, statecode)
        .then((result) => {
          this.Cities = result;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCurrentCity(countryID, state) {
      let statecode = "";
      const codesn = this.States.map((err) => {
        if (err.Name == state) {
          console.log(err);
          statecode = err.Id;
          return err.code;
        } else {
        }
      });
      this.getCities(countryID, statecode)
        .then((result) => {
          this.Cities = result;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchDirectors() {
      this.startLoader("Loading Company Directors...");
      this.getCompanyDirectors(this.companydata.userID, 0)
        .then((result) => {
          this.stopLoader();
          if (result.length > 0) {
            this.usersdata = result;
          } else {
            this.usersdata = "";
          }
        })
        .catch((err) => {
          this.errorMessage("Failed to get Directors." + err);
          this.stopLoader();
        });
    },

    CreateNewDirector() {
      this.startLoader("Creating Director...");
      this.userdata.CompanyId = this.companydata.userID;
      this.$validator.validateAll().then((result) => {
        if (
          !this.$validator.errors.has("FirstName") &&
          !this.$validator.errors.has("CountryID") &&
          !this.$validator.errors.has("Email") &&
          !this.$validator.errors.has("plainphone") &&
          !this.$validator.errors.has("DOB") &&
          !this.$validator.errors.has("DocumentTypeID") &&
          !this.$validator.errors.has("IDNumber")
        ) {
          this.$validator.reset();
          // if (this.files.length<1) {
          //   this.errorMessage("Upload atleast one document.");this.stopLoader();
          // }else{
          this.CreateDirector(this.userdata)
            .then((result) => {
              if (result.id && result.id.length > 0) {
                this.userdata.UserID = result.id;
                var formData = new FormData();
                for (var i = 0; i < this.files.length; i++) {
                  for (var i = 0; i < this.files.length; i++) {
                    var formData = new FormData();
                    formData.append("files", this.files[i].file);
                    formData.append("DocumentId", this.files[i].name);
                    formData.append("userId", result.id);
                    this.uploadCompanyKycDocument(formData).then(
                      (docsresult) => {
                        if (docsresult.code === "200") {
                          this.successMessage(
                            "User " +
                            this.files[i].name +
                            " document successfully."
                          );
                        } else {
                          this.errorMessage(
                            "Failed to upload KYC Document." +
                            docsresult.message
                          );
                        }
                      }
                    );
                  }
                }
                this.stopLoader();
                this.dialogFormVisible = false;
                this.fetchDirectors();
                this.successMessage(
                  "Director Created successifully with Documents. "
                );
              } else {
                this.stopLoader();
                this.dialogFormVisible = false;
                this.fetchDirectors();
                this.successMessage(
                  "Director Created successifully without Documents. "
                );
              }
            })
            .catch((err) => {
              this.errorMessage("Failed to create Director." + err);
              this.stopLoader();
            });
        }
        // }
        // else{
        //   this.stopLoader();}
      });
    },

    UpdateDirector() {
      this.startLoader("Updating Director...");
      this.userdata.CompanyId = this.companydata.userID;
      this.$validator.validateAll().then((result) => {
        if (
          !this.$validator.errors.has("FirstName") &&
          !this.$validator.errors.has("CountryID") &&
          !this.$validator.errors.has("Email") &&
          !this.$validator.errors.has("plainphone") &&
          !this.$validator.errors.has("DOB") &&
          !this.$validator.errors.has("DocumentTypeID") &&
          !this.$validator.errors.has("IDNumber")
        ) {
          this.$validator.reset();
          // if (this.files.length<1) {
          //   this.errorMessage("Upload atleast one document.");this.stopLoader();
          // }else{
          this.UpdateCompanyDirector(this.userdata)
            .then((result) => {
              if (result.id && result.id.length > 0) {
                this.userdata.UserID = result.id;
                var formData = new FormData();
                for (var i = 0; i < this.files.length; i++) {
                  for (var i = 0; i < this.files.length; i++) {
                    var formData = new FormData();
                    formData.append("files", this.files[i].file);
                    formData.append("DocumentId", this.files[i].name);
                    formData.append("userId", result.id);
                    this.uploadCompanyKycDocument(formData).then(
                      (docsresult) => {
                        if (docsresult.code === "200") {
                          this.successMessage(
                            "User " +
                            this.files[i].name +
                            " document successfully."
                          );
                        } else {
                          this.errorMessage(
                            "Failed to upload KYC Document." +
                            docsresult.message
                          );
                        }
                      }
                    );
                  }
                }
                this.stopLoader();
                this.dialogFormVisible = false;
                this.fetchDirectors();
                this.successMessage(
                  "Director Updated successifully with Documents. "
                );
              } else {
                this.stopLoader();
                this.dialogFormVisible = false;
                this.fetchDirectors();
                this.successMessage(
                  "Director Updated successifully without Documents. "
                );
              }
            })
            .catch((err) => {
              this.errorMessage("Failed to create Director." + err);
              this.stopLoader();
            });
        }
        // }
        // else{
        //   this.stopLoader();}
      });
    },

    onPickFile: function (event, id) {
      // console.log("log");
      // var elem = this.$refs.fileInput;
      // elem.click();
      this.$refs.files.click();
      this.filename = id;
    },

    handleIndividualFilesUpload() {
      let uploadedFiles = this.$refs.files.files;
      let size = event.target.files[0].size;
      // validate file size
      if (uploadedFiles[0].size > 5 * 1024 * 1024) {
        alert("Error : Exceeded size 5MB");
        uploadedFiles.splice(0, 1);
      }
      // validate whether PDF
      // else if(mime_types.indexOf(uploadedFiles.type) == -1) {
      //     alert('Error : Incorrect file type');
      //     return;
      // }

      /*3
        Adds the uploaded file to the files array
      */
      else {
        for (var i = 0; i < uploadedFiles.length; i++) {
          const product = this.files.find((p) => p.name === this.filename);
          if (!product) {
            this.iDFile.push({
              url: URL.createObjectURL(uploadedFiles[i]),
              name: this.filename,
            });
            this.files.push({ file: uploadedFiles[i], name: this.filename });
          } else {
            this.iDFile[i] = {
              url: URL.createObjectURL(uploadedFiles[i]),
              name: this.filename,
            };
            this.files[i] = { file: uploadedFiles[i], name: this.filename };
          }

          /*
          Initialize a File Reader object
        */
          let reader = new FileReader();
          /*
          Add an event listener to the reader that when the file
          has been loaded, we flag the show preview as true and set the
          image to be what was read from the reader.
        */
          //  for (var i=0; i<this.files.length; i++){
          reader.addEventListener(
            "load",
            function () {
              this.showPreview = true;
              this.imagePreview = reader.result;
            }.bind(this),
            false
          );
          /*
          Check to see if the file is not empty.
        */
          if (uploadedFiles[i]) {
            /*
          Ensure the file is an image file.
          */
            if (/\.(jpe?g|png|gif)$/i.test(uploadedFiles[i].name)) {
              /*
            Fire the readAsDataURL method which will read the file in and
            upon completion fire a 'load' event which we will listen to andthis.userdata.UserID
            display the image in the preview.
          */
              reader.readAsDataURL(uploadedFiles[i]);
            } else if (/\.(pdf)$/i.test(uploadedFiles[i].name)) {
              //  alert('pdf')
              reader.readAsArrayBuffer(uploadedFiles[i]);
            }
          }
          // }
        }
      }
    },

    /*
        Adds a file
      */
    addFiles: function (event, id) {
      this.$refs.files.click();
      //this.filename= event.target.textContent || event.target.innerText;
      //this.filename= event.target.dataset.id;
      this.filename = id;
    },
    handleFilesUpload() {
      let uploadedFiles = this.$refs.files.files;
      let size = event.target.files[0].size;
      // validate file size
      if (uploadedFiles[0].size > 10 * 1024 * 1024) {
        alert("Error : Exceeded size 10MB");
        uploadedFiles.splice(0, 1);
      }
      // validate whether PDF
      // if(mime_types.indexOf(uploadedFiles.type) == -1) {
      //     alert('Error : Incorrect file type');
      //     return;
      // }

      /*3
        Adds the uploaded file to the files array
      */

      //this.filename=this.filename.replace(/ /g,"_");
      for (var i = 0; i < uploadedFiles.length; i++) {
        const product = this.files.find((p) => p.name === this.filename);
        if (!product) {
          this.pdfSrc.push({
            url: URL.createObjectURL(uploadedFiles[i]),
            name: this.filename,
          });
          this.files.push({ file: uploadedFiles[i], name: this.filename });
        } else {
          this.pdfSrc[i] = {
            url: URL.createObjectURL(uploadedFiles[i]),
            name: this.filename,
          };
          this.files[i] = { file: uploadedFiles[i], name: this.filename };
        }
        /*
        Initialize a File Reader object
      */
        let reader = new FileReader();
        /*
        Add an event listener to the reader that when the file
        has been loaded, we flag the show preview as true and set the
        image to be what was read from the reader.
      */
        //  for (var i=0; i<this.files.length; i++){
        reader.addEventListener(
          "load",
          function () {
            this.showPreview = true;
            this.imagePreview = reader.result;
          }.bind(this),
          false
        );
        /*
        Check to see if the file is not empty.
      */
        if (uploadedFiles[i]) {
          /*
          Ensure the file is an image file.
        */
          if (/\.(jpe?g|png|gif)$/i.test(uploadedFiles[i].name)) {
            /*
            Fire the readAsDataURL method which will read the file in and
            upon completion fire a 'load' event which we will listen to and
            display the image in the preview.
          */
            reader.readAsDataURL(uploadedFiles[i]);
          } else if (/\.(pdf)$/i.test(uploadedFiles[i].name)) {
            //  alert('pdf')
            reader.readAsArrayBuffer(uploadedFiles[i]);
          }
        }
        // }
      }
    },
    saveUserProfilePicture(userdata) {
      if (this.img) {
        const file = this.DataURIToBlob(this.img);
        var formData = new FormData();
        formData.append("userId", userdata.id);
        formData.append("files", file, "image.jpg");
        var isFormDataEmpty = true;
        for (var [key, value] of formData.entries()) {
          if (value !== "null") {
            isFormDataEmpty = true;
          } else {
            isFormDataEmpty = false;
          }
          break;
        }
        if (isFormDataEmpty) {
          this.uploadUserProfilePicture(formData).then((result) => {
            //
            if (result.code === "200") {
            } else {
              //this.errorMessage("Failed to upload Transaction Supporting Document.");
            }
          });
        }
      }
    },

    onUpdatecustomerMobileNumber(payload) {
      this.userdata.PhoneNumber = payload.formattedNumber;
    },
    DataURIToBlob(dataURI) {
      const splitDataURI = dataURI.split(",");
      const byteString =
        splitDataURI[0].indexOf("base64") >= 0
          ? atob(splitDataURI[1])
          : decodeURI(splitDataURI[1]);
      const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i);

      return new Blob([ia], { type: mimeString });
    },

    onCapture() {
      this.img = this.$refs.webcam.capture();
      console.log("On Started Event", this.img);
    },
    onStarted(stream) {
      console.log("On Started Event", stream);
    },
    onStopped(stream) {
      console.log("On Stopped Event", stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      console.log("On Error Event", error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      console.log("On Camera Change Event", deviceId);
    },
  },
  mounted() {
    //this.fetchDirectors();
  },
  created() {
    const that = this;
    var id = router.currentRoute.params.id;
    that
      .getCountries()
      .then((countriesList) => {
        that.countries = countriesList;
        that
          .getUserKYCProfile(id)
          .then((result) => {
            //console.log(result.items[0]);
            that.companydata = result.items[0];
            that.userdata.countryID = result.items[0].countryID;
            that.fetchDirectors();
            that.getDocumentTypesByCountryId(1, result.items[0].countryID)
              .then((documentTypes) => {
                this.identityDocumentTypes = documentTypes;
              })
              .catch((err) => {
                this.errorMessage("An error occured");
              });

            const codesn = that.countries.map((data) => {
              if (data.id == that.userdata.countryID) {
                this.countrycode = data.code;
                return data.code;
              } else {
              }
            });
            that.getStates(result.items[0].countryID).then((result) => {
              that.States = result;
              this.getCurrentCity(
                result.items[0].countryID,
                this.userdata.state
              );
            });
          })
          .catch((err) => {
            that.errorMessage("An Error Occured. " + err);
          });
      })
      .catch((err) => {
        that.errorMessage("An Error Occured. " + err);
      });
  },
  mixins: [PermissionsMixins],
};
</script>
<style>
.table-responsive {
  margin: 10px 0;
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-wrapper {
  padding: 10px 5px;
  box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
  width: 100%;
}

.table-title {
  padding-bottom: 15px;
  background: rgb(231, 112, 22);
  color: #fff;
  padding: 16px 30px;
  min-width: 100%;
  border-radius: 3px 3px 0 0;
}

.table-title h2 {
  margin: 5px 0 0;
  font-size: 24px;
}

.table-title .btn {
  color: #fff;
  float: right;
  font-size: 13px;
  border: none;
  min-width: 50px;
  border-radius: 2px;
  background-color: #0a1d37;
  border-color: #0a1d37;
  border: none;
  outline: none !important;
  margin-left: 10px;
}

.table-title .btn i {
  float: left;
  font-size: 21px;
  margin-right: 5px;
  color: rgb(231, 112, 22);
  line-height: 1.2;
}

.table-title .btn span {
  float: left;
  margin-top: 2px;
}

table.table td i {
  font-size: 19px;
  opacity: 0.9;
  margin: 0 5px;
  line-height: 1;
}

table.table td a {
  float: right;
  font-size: 13px;
  display: flex;
  border-radius: 2px;
  border: none;
  outline: none !important;
  margin-left: 10px;
}

.text-green {
  color: green;
}

.text-white {
  color: white;
}

.text-red {
  color: red;
}

table.dataTable tbody tr {
  background-color: #191d24;
}

table.dataTable {
  margin-left: 0px;
  text-align: left;
}

.avatar-box {
  background: #3773e2;
  margin-bottom: 50px;
  position: relative;
}

.avatar-box img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  position: relative;
  bottom: -50px;
  display: block;
  margin: 0 auto;
  background: white;
  border: 2px solid #3773e2;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.dataTables_filter label,
.dataTables_wrapper .dataTables_filter input {
  color: white !important;
}

.dataTables_wrapper .dataTables_filter input ::placeholder,
.dataTables_wrapper .dataTables_filter input ::-ms-input-placeholder {
  color: white !important;
}

.dataTables_wrapper .dataTables_paginate a.paginate_button {
  color: white !important;
}
</style>